import { render, staticRenderFns } from "./OpenPurchaseOrders.vue?vue&type=template&id=bb86d4e8&"
import script from "./OpenPurchaseOrders.vue?vue&type=script&lang=js&"
export * from "./OpenPurchaseOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports